import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from '@root/src/environments/environment';

interface VersionStamp {
  commitSha?: string;
}

export class CacheBustingTranslateLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly production = environment.production,
  ) {}

  getTranslation(lang: string): Observable<object> {
    // The committed version.json sha does not change during ng serve, so a stable ?v= keeps yesterday's dictionary.
    if (!this.production) {
      return this.http.get(`./assets/i18n/${lang}.json?v=${Date.now()}`);
    }
    return this.http.get<VersionStamp>('./assets/version.json').pipe(
      map(info => (typeof info?.commitSha === 'string' && info.commitSha ? info.commitSha : String(Date.now()))),
      catchError(() => of(String(Date.now()))),
      switchMap(bust =>
        this.http.get(`./assets/i18n/${lang}.json?v=${encodeURIComponent(bust)}`),
      ),
    );
  }
}
